import React from "react";
import { useParams } from "react-router";
import ContentWrapper from "../../components/layout/ContentWrapper";
import { useCustomTranslation } from "../../helpers/translateHelpers";
import { NewPasswordForm, useAuth } from "../../components";
import { NewPasswordFormValues } from "../../components/forms/password/NewPasswordForm";
import { publicCustomerUserClient } from "../../api";
import {
  saveAccessToken,
  saveRefreshToken,
  saveRefreshTokenId,
} from "../../helpers/tokenManager";
import { useNavigate } from "../../helpers/navigationHelpers";

type RouteParams = "customerUserId" | "passwordResetGuid";

const PasswordResetPage: React.FC = (): React.ReactElement => {
  const { setUser, setOtherAccounts, setAuthenticated } = useAuth();
  const { tCommon, t } = useCustomTranslation();

  const params = useParams<RouteParams>();
  const navigate = useNavigate();

  const handleSubmit = async (values: NewPasswordFormValues) => {
    const result = await publicCustomerUserClient.completePasswordReset({
      customerUserId: params.customerUserId ?? "",
      passwordResetGuid: params.passwordResetGuid ?? "",
      password: values.password,
    });

    if (result.success && result.customerUser) {
      saveRefreshToken(result.refreshToken);
      saveRefreshTokenId(result.refreshTokenId);
      saveAccessToken(result.accessToken);
      setUser(result.customerUser);
      setOtherAccounts(result.contactPeople);
      setAuthenticated(true);

      await navigate.goTo(`/`);
    }
  };

  return (
    <ContentWrapper small largePadding htmlTitle={t("reset_password")}>
      <h1>{tCommon("customer_portal")}</h1>
      <p className="mb-6">{tCommon("password_create_description")}</p>
      <p className="mb-2 text-sm font-bold">{tCommon("create_password")}</p>
      <NewPasswordForm onSubmit={handleSubmit} />
    </ContentWrapper>
  );
};

export default PasswordResetPage;
